import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  container: {
    marginTop: 10,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerSubTitle: theme => ({
    ...Fonts.type.bold,
    fontSize: 25,
    lineHeight: 32,
    color: theme.colors.headerColor,
  }),
  headerDescription: theme => ({
    fontSize: 16.6,
    color: theme.colors.headerColor,
    lineHeight: 20,
    marginVertical: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 17
  }),
  headerRightSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerRightSectionText: theme => ({
    fontSize: 16,
    color: theme.colors.usageSubTitle,
    marginRight: 7,
    paddingTop: 4,
  }),
  illustrationImage: {
    alignSelf: 'center',
    marginBottom: 33,
  },
});
